module.exports = __webpack_public_path__ + "img/authen_wait.021c561c.png";